import Permissions from '@/permissions'
import Setting from '@/views/setting/Index'
import { reasonRouters } from '@/routers/setting/reason'
import { membershipRouters } from '@/routers/setting/membership'
import { backgroundRouters } from '@/routers/setting/background'
import { assignLoanOfficerRouters } from '@/routers/setting/assignLoanOfficer'
import { assignLoanOfficerOldClientRouters } from '@/routers/setting/assignLoanOfficerOldClient'

export const settingRouters = {
  path: 'settings',
  name: 'settings',
  component: Setting,
  redirect: 'membership',
  meta: {
    permissions: [Permissions.backend.setting.manage]
  },
  children: [
    reasonRouters,
    membershipRouters,
    backgroundRouters,
    assignLoanOfficerRouters,
    assignLoanOfficerOldClientRouters
  ]
}
